import { useRef, useState } from 'react';
import { useDrag } from '@use-gesture/react';
import { motion } from 'framer-motion';

import styles from './styles.module.scss';
import { useViewport } from '../../hooks';
import { BreakpointMobile } from '../../constants/ui';

const Sidebar = ({ children, isSeasonPage, hideOnTablet, isPanelOpened = false, openedTopDefault = 108, isStatic = false }) => {
  const { widthViewport } = useViewport();
  const [isOpen, setIsOpen] = useState(isPanelOpened);
  const dragHandleRef = useRef(null);

  const screenHeight = window.innerHeight;
  const closedTop = isSeasonPage ? screenHeight - 60 - 90 : screenHeight - 76 - 90;
  const openedTop = openedTopDefault;

  const toggleMenu = (open) => {
    setIsOpen(open);
  };

  useDrag(
    ({ movement: [, y], direction: [, dy], velocity }) => {
      if (dy < 0 && velocity > 0.3) toggleMenu(true);
      if (dy > 0 && velocity > 0.3) toggleMenu(false);
    },
    { target: dragHandleRef }
  );

  return (
    <>
      {!hideOnTablet && widthViewport > BreakpointMobile ? (
        <aside className={styles.sidebar}>{children}</aside>
      ) : (
        <motion.div
          ref={dragHandleRef}
          className={`${styles.sidebar} ${isOpen ? styles.sidebarActive : ''} ${isSeasonPage ? styles.sidebarSeason : ''} ${isStatic ? styles.sidebarStatic : ''}`}
          drag="y"
          dragConstraints={{ top: 0, bottom: 0 }}
          onDragEnd={(_, info) => {
            if (info.velocity.y > 300) toggleMenu(false);
            if (info.velocity.y < -300) toggleMenu(true);
          }}
          animate={{ top: isOpen ? openedTop : closedTop }}
          transition={{ type: 'spring', stiffness: 300, damping: 40 }}
        >
          {!isStatic && <button className={styles.sidebarTop} onClick={() => toggleMenu(!isOpen)}></button>}
          {children}
        </motion.div>
      )}
    </>
  );
};

export default Sidebar;
